module.exports = __webpack_public_path__ + "img/acf4079.png";